// @flow
import {Subscription} from 'digicel-kaizen-library';
import React, {PureComponent} from 'react';
import {
  Dimensions,
  Image,
  RefreshControl,
  ScrollView,
  StyleSheet,
  View,
} from 'react-native';
import runAfterInteractions from '../../utils/runAfterInteractions';
import {Text} from 'trpc-react-native-ui';
import PaymentAuthentications from '../../components/payments/PaymentAuthentications/PaymentAuthentications.container';
import {PlanFrame, PlanSummaryFrame} from '../../components/plan';
import TabBarScene from '../../components/tabBarScene';
import {UsageFrame} from '../../components/usage';
import config from '../../config';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import VouchersFrame from '../Vouchers/components/VouchersFrame';
import {PhonePicker} from './components';
import AddInternationalButton from './components/AddInternationalButton.container';
import Orders from './components/Orders';
import {PendingOrderStatus} from './components/PendingOrderStatus';
import {RoamingFrames, TravelFrames} from './components/RoamingFrames';
import {SuspensionStatus} from './components/SuspensionStatus';

class Dashboard extends PureComponent<Props> {
  styles = getStyles();

  _onRefresh = () => this.props.fetchData(true);

  componentDidMount() {
    runAfterInteractions(() => {
      this.props.fetchData();
      this.props.selectEsim(false);
    });
  }

  renderVouchersFrame = () => {
    return this.props.filteredAvailableVouchers &&
      this.props.filteredAvailableVouchers.length > 0 ? (
      <VouchersFrame comeFrom="dashboard" />
    ) : null;
  };

  getDashboardContent = () => {
    const styles = this.styles;

    if (this.props.isNetworkFailure) {
      return (
        <Text style={this.styles.emptyText}>
          {I18n.t('error.unableToJoinServer')}
        </Text>
      );
    }

    if (this.props.currentSubscription?.status === 'PENDING_ACTIVE') {
      return (
        <>
          <PaymentAuthentications />
          <PlanSummaryFrame
            fromDashboard
            showTitle
            subscription={this.props.currentSubscription}
            unavailablePlanText={I18n.t(
              'Dashboard.Plan.unavailablePlanOnDashboard',
            )}
          />
        </>
      );
    }

    return (
      <View style={styles.activatedContainer}>
        <PaymentAuthentications />
        {!config.hidePendingOrderPanelOnDashboard && (
          <PendingOrderStatus style={styles.frameContainer} />
        )}
        <SuspensionStatus style={styles.frameContainer} />
        <PlanFrame style={styles.frameContainer} />
        {this.renderVouchersFrame()}
        <UsageFrame style={styles.frameContainer} />
        {config.displayTravelUsages && (
          <TravelFrames style={styles.frameContainer} />
        )}
        {config.displayRoamLikeHome && <RoamingFrames />}
        {this.props.canAddInternational && (
          <AddInternationalButton
            disabled={this.props.hasUnauthenticatedPayment}
          />
        )}
      </View>
    );
  };

  render() {
    const styles = this.styles;

    return (      
      <TabBarScene
        fetchData={this.props.fetchData}
        isFailure={this.props.isFailure}
        isFetching={this.props.isFetching}>        
        <View style={styles.container} testID="dashboardScreen">
          <PhonePicker />
          {
            this.props.canShowFreeTrialBanner && (
              <View style={this.styles.freeTrialBannerContainer}><Text style={this.styles.freeTrialBannerText}>🎁 {I18n.t('Dashboard.freeTrialBanner')}</Text></View>)
          }
          <View style={styles.innerContainer}>
            {theme.footerImage && (
              <Image source={theme.footerImage} style={styles.footerImage} />
            )}
            {!this.props.isSubscriptionVisible ? (
              <Orders />
            ) : (
                <ScrollView
                  refreshControl={<RefreshControl
                    onRefresh={this._onRefresh}
                    refreshing={this.props.isLoading} />}
                  contentContainerStyle={this.props.isNetworkFailure && this.styles.emptyContainer}>
                  {this.getDashboardContent()}
                </ScrollView>
              )}
          </View>
        </View>
      </TabBarScene>
    );
  }
}

type Props = {
  canAddInternational: boolean,
  currentSubscription?: Subscription,
  fetchData: Function,
  installESim: Function,
  hasUnauthenticatedPayment: boolean,
  isFailure: boolean,
  isFetching: boolean, // TODO refacto
  isLoading: boolean,
  isNetworkFailure: boolean,
  isSubscriptionVisible: boolean,
  fetchVouchers: Function,
  filteredAvailableVouchers: Object[],
};

const getStyles = () =>
  StyleSheet.create({
    activatedContainer: {
      paddingBottom: 8,
    },
    container: {
      flex: 1,
    },
    emptyContainer: {
      alignItems: 'center',
      flex: 1,
      justifyContent: 'center',
    },
    emptyText: {
      color: theme.emptyTextColor,
      fontSize: 16,
      textAlign: 'center',
    },
    freeTrialBannerContainer: {
      alignItems: 'center',
      justifyContent: 'center',      
      backgroundColor: "#B6FF8E",
    },
    freeTrialBannerText: {
      fontSize: 16,
      textAlign: 'center',
      color: "#397E14",
      padding: 8
    },
    footerImage: {
      bottom: 0,
      height: 60,
      left: 0,
      opacity: 0.7,
      position: 'absolute',
      width: Dimensions.get('window').width,
    },
    frameContainer: {
      marginBottom: 8,
    },
    innerContainer: {
      backgroundColor: theme.dashboardBackgroundColor,
      flex: 1,
      paddingHorizontal: 8,
      paddingTop: 8,
    },
  });

export default Dashboard;
